<template>
  <div>
    <div class="justify-content-end">
      <control-mini :countChecked="rowSelecteds.length" @doAddNew="doAddNew" @doEdit="handleEdit"></control-mini>
    </div>
    <soft-table
      @rowSelected="tbSetRowSelected"
      @rowClicked="tbRowClicked"
      class="table align-items-center table-flush"
      tbody-classes="list"
      :pending="false"
      :dataTable="reasons"
      :fields="fields"
      :minHeight="$hMainContent - 164"
      :showAll="true"
      :noDelete="true"
      @doEditRow="handleEdit"
      :contextMenus="[
        {
          key: 'convert',
          icon: 'fa-edit',
          label: 'Chuyển đổi đơn vị'
        },
        {
          key: 'history',
          icon: 'fa-history',
          label: 'Lịch sử tồn kho'
        }
      ]"
      @contextMenuItemClick="tbHandleContextMenuItemClick"
      ref="soft-table"
    >
      <template>
        <pagination
          class="mr-2 my-1"
          slot="footer"
          :total="listQuery.total"
          :perPage="listQuery.limit"
          :value="listQuery.page"
          @change="pagChange"
        />
      </template>
    </soft-table>
    <modal :show="visible" @close="visible = false" modalClasses="modal-xxl">
      <div slot="header">
        <h3>Thêm/cập nhật diễn giải</h3>
      </div>
      <block ref="bmdal" style="min-height: 250px; overflow-y: auto;">
        <ValidationObserver ref="csInfo" v-slot="{ handleSubmit }">
          <form role="form" @submit.prevent="handleSubmit">
            <div class="row">
              <div class="col-3">
                <base-input label="ID" name="id" v-model="reason.id"> </base-input>
              </div>
              <div class="col-3">
                <ValidationProvider name="Mã tìm kiếm" v-slot="{ errors }">
                  <base-input
                    label="Mã"
                    :error="errors[0]"
                    v-model="reason.key"
                    :valid="errors.length == 0"
                  ></base-input>
                </ValidationProvider>
              </div>
              <div class="col-12 mt-3">
                <ValidationProvider name="Diễn giải" rules="required" v-slot="{ errors }">
                  <!-- <base-input label="Tên sản phẩm" :error="errors[0]" v-model="info.name" :valid="errors.length == 0"></base-input> -->
                  <div
                    class="form-groups"
                    :class="[{ 'has-danger': errors.length > 0 }, { 'has-success': errors.length == 0 }]"
                  >
                    <label class="form-control-label" for="note"> Diễn giải</label>
                    <b-textarea
                      id="note"
                      placeholder="Diễn giải"
                      label="Diên"
                      v-model="reason.name"
                      rows="4"
                    ></b-textarea>
                    <div
                      class="text-danger invalid-feedback"
                      style="display: block; padding: 0px 5px 10px 10px; font-style: italic; opacity: 0.7;"
                      v-if="errors.length > 0"
                    >
                      {{ errors[0] }}
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </form>
          <hr />
          <button type="button" @click="handleClose" class="btn btn-secondary">
            Đóng
          </button>
          <button type="submit" @click="doSave(0)" class="btn btn-dark">
            Lưu đóng (F4)
          </button>
        </ValidationObserver>
      </block>
      <event @doSave="doSave(0)" @doCancel="handleClose"></event>
    </modal>
  </div>
</template>
<script>
import { productService } from '@/_services';
export default {
  props: {},
  components: {},
  data() {
    return {
      fields: [
        {
          key: 'id',
          stickyColumn: true,
          class: 'col-fix checkbox'
        },
        {
          key: 'key',
          stickyColumn: true,
          sortable: true,
          label: 'Mã tìm kiếm',
          class: 'col-fix'
        },
        {
          key: 'name',
          tdClass: 'text-left',
          label: 'Nội dung diễn giải'
        },
        {
          key: 'action',
          class: 'text-center col-fix'
        }
      ],
      reason: {
        id: '',
        code: '',
        name: ''
      },
      listQuery: {
        page: 1,
        limit: 30,
        total: 0
      },
      visible: false,
      reasons: [],
      isNew: false,
      rowSelecteds: []
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    tbRowClicked: function(row) {},
    tbSetRowSelected: function(rows) {
      this.rowSelecteds = rows;
    },
    handleEdit: function(row) {
      if (this.rowSelecteds.length > 0) this.reason = Object.assign({}, this.rowSelecteds[0]);
      this.isNew = false;
      this.visible = true;
    },
    tbHandleContextMenuItemClick: function(item) {},
    handleClose: function() {
      this.visible = false;
    },
    doAddNew() {
      this.visible = true;
      this.isNew = true;
      this.reason = {
        id: '',
        code: '',
        name: ''
      };
    },
    fetchData() {
      var self = this;
      productService.findReason(this.listQuery).then(res => {
        self.reasons = res.data.data;
        self.listQuery.total = res.data.total;
        self.$refs['soft-table'].selectRow(this.lastIndexCustomerSelected);
      });
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    doSave(type) {
      var self = this;
      if (!this.visible) return;
      this.$refs.csInfo.validate().then(success => {
        if (!success) return;
        this.$refs.bmdal.block();
        productService
          .saveReason(self.reason)
          .then(res => {
            this.fetchData();
            self.$alertify.success(res.message, {
              duration: 4000
            });
            if (type == 0) {
              self.visible = false;
            }
          })
          .catch(err => {
            if (err.data) {
              err.data.forEach(element => {
                let errObj = {};
                errObj[element.context.key] = [element.message];
                self.$refs.csInfo.setErrors(errObj);
              });
            }
          })
          .finally(() => {
            this.$refs.bmdal.unBlock();
          });
      });
    }
  }
};
</script>
